<template>
  <div class="page-container">
    <div class="page-container-header">
      <span class="title">批量上传</span>
      <el-button type="primary" size="small" plain @click="downloadTemplate"
        >下载模版</el-button
      >
    </div>
    <div class="page-container-body">
      <el-card
        class="first-pageStep-container"
        shadow="hover"
        v-if="pageStep === 1"
      >
        <div slot="header">
          <span class="brand-color">上传文件</span>
        </div>
        <el-form label-width="120px" :inline="false" size="medium">
          <el-form-item label="技能点：">
            <select-skill-stack
              size="medium"
              class="w-360 mr-12"
              :value.sync="basicInfo.stackId"
            ></select-skill-stack>
          </el-form-item>
          <el-form-item label="关联老师：">
            <el-select
              class="w-360"
              v-model="basicInfo.teacherId"
              filterable
              remote
              placeholder="请输入老师姓名"
              :remote-method="searchTeacher"
              :loading="searchNameLoading"
            >
              <el-option
                v-for="item in teacherList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上传文件：">
            <el-upload
              action=""
              :http-request="() => {}"
              :show-file-list="false"
              :before-upload="handleBeforeUpload"
              :drag="true"
            >
              <div v-if="importFile" class="upload-btn">
                <div class="upload-delete" @click.stop="importFile = null">
                  <i class="el-icon-delete mr-4"></i>
                  刪除
                </div>
                <div class="upload-file">
                  <zhu-svg svg-class="svg-class" svg-name="file"></zhu-svg>
                  <span class="text">{{ importFile.name }}</span>
                </div>
              </div>
              <div v-else class="upload-btn">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="">
            <el-button
              class="w-360"
              type="primary"
              @click="handleToNext"
              :loading="nextLoading"
              >下一步</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
      <el-card shadow="hover" v-if="pageStep === 2" id="topic-card">
        <div slot="header">
          <span class="brand-color">题目详情</span>
        </div>
        <el-form
          class="mt-12"
          label-width="140px"
          :model="topicInfo"
          :rules="topicRules"
          ref="topicInfo"
          size="mini"
        >
          <el-form-item
            label="题目类别："
            prop="question_type"
            :show-message="false"
          >
            <el-radio-group
              v-model="topicInfo.question_type"
              size="mini"
              :show-message="false"
            >
              <el-radio
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
            <el-tooltip effect="light" style="margin-left:20px;">
              <div slot="content" class="tooltip-content">
                <div class="tooltip-content-item">
                  <span class="strong-name">概念题：</span>
                  <p class="desc">
                    以考察语法、执行流程、配置、记忆类题目，通常题目中较少出现的代码；
                  </p>
                </div>
                <div class="tooltip-content-item">
                  <span class="strong-name">代码题：</span>
                  <p class="desc">
                    以考察代码运行结果，或者是部分代码填空，或根据结果修改某几行代码的题目；
                  </p>
                </div>
                <div class="tooltip-content-item">
                  <span class="strong-name">场景题：</span>
                  <p class="desc">
                    与工作应用背景相关的题目，考察知识的实际应用，例如：在我们使用对象存储（OSD）进行管理对象的过程中，以下哪种方法可以提高系统的读写速度？
                  </p>
                </div>
                <div class="tooltip-content-item">
                  <span class="strong-name">其他：</span>
                  <p class="desc">
                    出现在技术类同时非代码类的题目中。例如工具的使用，安装，插件优化等等；
                  </p>
                </div>
              </div>
              <el-link :underline="false"
                ><i class="el-icon-question"></i
              ></el-link>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="难度等级：" prop="level" :show-message="false">
            <el-radio-group v-model="topicInfo.level" size="medium">
              <el-radio-button
                v-for="item in levelList"
                :label="item.value"
                :key="item.value"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
            <el-tooltip effect="light" style="margin-left:20px;">
              <div slot="content" class="tooltip-content">
                <div class="tooltip-content-item">
                  <span class="strong-name">简单：</span>
                  <p class="desc">
                    <strong>记忆型、概念型</strong
                    >，以考察语法，执行流程，配置，记忆等元素组成的题目，不涉及底层逻辑或数据库，不涉及复杂的逻辑代码；
                  </p>
                </div>
                <div class="tooltip-content-item">
                  <span class="strong-name">普通：</span>
                  <p class="desc">
                    <strong>理解</strong
                    >，2个以上知识点的综合应用，不属于记忆性的题目，解决实际问题，综合知识的逻辑或者代码，如：一个知识点+数据库；
                  </p>
                </div>
                <div class="tooltip-content-item">
                  <span class="strong-name">困难：</span>
                  <p class="desc">
                    <strong>应用</strong
                    >，框架整合、框架操作数据库、源码解读、系统优化，多知识点融合，技术经验积累，经验判断，解决方案或者有一定挑战的编程等。
                  </p>
                </div>
              </div>
              <el-link :underline="false"
                ><i class="el-icon-question"></i
              ></el-link>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="所属知识点："
            prop="knowledge_ids"
            :show-message="false"
          >
            <el-button size="medium" @click="showSelectDialog()"
              >选择知识点</el-button
            >
            <el-tooltip effect="light" style="margin-left:20px;">
              <div slot="content" class="tooltip-content">
                <div class="tooltip-content-item">
                  <span class="strong-name">知识树：</span>
                  <p class="desc">
                    是掌握该技能所需的核心知识结构，一棵知识树应该覆盖其全部重要知识点；
                    根据题目核心考察知识点，勾选题目对应知识树上的知识点，最多关联
                    2 个。
                  </p>
                </div>
              </div>
              <el-link :underline="false"
                ><i class="el-icon-question"></i
              ></el-link>
            </el-tooltip>
            <div v-for="(item, index) in selectKnowledgeArr" :key="index">
              <el-tag size="medium">{{ item.name }}</el-tag>
            </div>
          </el-form-item>
          <el-form-item label="行业分类：">
            <el-cascader
              v-model="topicInfo.common_industries"
              :options="industryList"
              :props="optionProps"
              class="w-400"
              placeholder="请选择行业分类"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="建议最长答题时间：" prop="time_max">
            <el-input-number
              v-model="topicInfo.time_max"
              label="描述文字"
              size="small"
              :min="1"
            ></el-input-number>
            <span style="margin-left: 10px; margin-right: 10px">
              单位 / 秒</span
            >
            <el-popover
              placement="top-start"
              width="500"
              title="提示"
              trigger="hover"
              content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
            >
              <p class="popover-title">
                用户作答最长不超过的答题时长，超出时长未作答时将自动判错。请根据题目实际情况设置，一般情况下
              </p>
              <ul class="popover-list">
                <li class="popover-item">简单题目60秒</li>
                <li class="popover-item">普通题目90秒</li>
                <li class="popover-item">困难题目120秒</li>
              </ul>

              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </el-form-item>
          <el-form-item
            label="题目来源："
            prop="source_type"
            :show-message="false"
          >
            <el-radio-group v-model="topicInfo.source_type">
              <el-radio
                v-for="(item, index) in sourceList"
                :key="index"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <div class="language-container">
            <div class="language-box">
              <div class="language-title">中文</div>
              <el-form-item label="题干：" prop="stem" :show-message="false">
                <template slot="label">
                  题干：<el-tooltip effect="light">
                    <div slot="content" class="tooltip-content">
                      <div class="tooltip-content-item">
                        <span class="strong-name" style="margin-right:12px;"
                          >题目设计要求：</span
                        >
                        <div class="desc">
                          <ul>
                            <li>
                              题目符合实效性（最新版本或主流版本），没有版本依赖
                              ；
                            </li>
                            <li>题目考察核心知识点；</li>
                            <li>题干清晰无歧义，无错别字，无超链接；</li>
                            <li>
                              专有名词书写格式要求按官方写法；（
                              如：MySQL、MongoDB ）
                            </li>
                            <li>图片清晰无水印；</li>
                            <li>
                              代码格式正确、缩进正常，可运行 ，无多余转义字符。
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <el-link :underline="false"
                      ><i class="el-icon-question"></i
                    ></el-link>
                  </el-tooltip>
                </template>
                <Markdown
                  class="w-90pc min-h-200 min-w-400"
                  :value.sync="topicInfo.stem"
                  defaultOpen="edit"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  option="assign_topic"
                ></Markdown>
              </el-form-item>
              <el-form-item
                v-for="(option, index) in topicInfo.options"
                :key="index"
                :label="`选项 ${index + 1}：`"
                :prop="`options[${index}].content`"
                :rules="{ required: true, trigger: 'blur' }"
                :show-message="false"
              >
                <template slot="label">
                  选项 {{ index + 1 }}：
                  <el-tooltip effect="light">
                    <div slot="content" class="tooltip-content">
                      <div class="tooltip-content-item">
                        <span class="strong-name" style="margin-right:12px;"
                          >选项设计要求：</span
                        >
                        <div class="desc">
                          <ul>
                            <li>
                              四个选项设置合理、无序号、无方向指示词；（如ABC，以上都对）；
                            </li>
                            <li>
                              选项语句逻辑通顺，注意换行排版，没有错别字；
                            </li>
                            <li>正确选项要经过验证是题目的正确答案；</li>
                            <li>选项末尾不要有任何标点符号；</li>
                            <li>
                              选项不允许随意设置“其他都对”，“其他都错”这样没太大意义的选项。
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <el-link :underline="false"
                      ><i class="el-icon-question"></i
                    ></el-link>
                  </el-tooltip>
                </template>
                <el-radio v-model="topicInfo.correctIndex" :label="index"
                  >正确答案</el-radio
                >
                <div class="topic-option">
                  <!-- <div class="item-float-delete">
                    <el-link
                      icon="el-icon-delete"
                      :underline="false"
                      type="danger"
                      @click="deleteOption(index)"
                    ></el-link>
                  </div> -->
                  <Markdown
                    :value.sync="option.content"
                    defaultOpen="edit"
                    space="_for_kungfu_sub_project"
                    folder="fuwu"
                    option="assign_topic"
                    class="min-w-400 min-h-200"
                  ></Markdown>
                </div>
              </el-form-item>
              <el-form-item
                label="解析："
                prop="analysis"
                :show-message="false"
              >
                <template slot="label">
                  解析：
                  <el-tooltip effect="light">
                    <div slot="content" class="tooltip-content">
                      <div class="tooltip-content-item">
                        <span class="strong-name" style="margin-right:12px;"
                          >解析填写要求：</span
                        >
                        <div class="desc">
                          <ul>
                            <li>
                              答案解析简洁明了，逻辑清晰，能够说明选择正确答案的原因。
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <el-link :underline="false"
                      ><i class="el-icon-question"></i
                    ></el-link>
                  </el-tooltip>
                </template>

                <Markdown
                  class="w-90pc min-h-200 min-w-400"
                  :value.sync="topicInfo.analysis"
                  defaultOpen="edit"
                  space="_for_kungfu_sub_project"
                  folder="fuwu"
                  option="assign_topic"
                ></Markdown>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="preview-btn">
          <zhu-button
            text="预览题目"
            :shadow="false"
            type="primary"
            icon="el-icon-view"
            @click="previewVisible = true"
          >
          </zhu-button>
          <zhu-button
            :text="
              questionIndex + 1 >= sheetData.length ? '完成上传' : '跳过该题'
            "
            class="ml-12"
            :shadow="false"
            type="primary"
            plain
            icon="el-icon-position"
            @click="skipThisTopic"
          >
          </zhu-button>
        </div>
      </el-card>
    </div>
    <el-dialog
      title="选择知识点"
      :visible.sync="selectVisible"
      width="600px"
      center
    >
      <el-input
        placeholder="输入关键字进行过滤"
        v-model="filterText"
        size="mini"
        class="mb-12 w-49pc"
      >
      </el-input>
      <el-alert type="warning" :closable="false" class="mb-12"
        ><i class="el-icon-info"></i> 难度等级：R1-R5,
        对应关系：零基础(R1)、简单(R2)、一般(R3)、困难(R4)、非常困难(R5)<br />
        <i class="el-icon-info"></i> 掌握程度：P1-P5,
        对应关系：了解(P1)、熟悉(P2)、掌握(P3)、精通(P4)、专家(P5)<br />
        <i class="el-icon-info"></i>
        知识点后的题目数量，为现在已审核通过的题目数量 <br />
        <i class="el-icon-info"></i>
        每道题目最多选择2个知识点</el-alert
      >
      <el-alert type="success" :closable="false" class="mb-12"
        ><i class="el-icon-info"></i> 表格知识点：{{ topicInfo.knowledge_names
        }}<br
      /></el-alert>
      <div class="dialog-tree-container" v-loading="dialogLoading">
        <el-tree
          :data="tree"
          :props="treeProps"
          node-key="id"
          :default-checked-keys="topicInfo.knowledge_ids"
          :highlight-current="true"
          :expand-on-click-node="false"
          default-expand-all
          show-checkbox
          :filter-node-method="filterNode"
          ref="tree"
          @node-click="handleNodeClick"
          @check="handleNodeCheck"
          :check-strictly="true"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span class="tree-label" :class="node.id">
              <span
                >{{ data.text }}
                <span v-if="data.difficult_level">
                  - R{{ data.difficult_level }}
                </span>
                <span v-if="data.mastery_level">
                  - P{{ data.mastery_level }}</span
                >
              </span>
              <span>{{ getQuestionCount(data) }}</span>
            </span>
          </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSelectInfo">取 消</el-button>
        <el-button type="primary" @click="selectKnowledgePoint"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="预览题目"
      :visible.sync="previewVisible"
      width="850px"
      :show-close="false"
      center
    >
      <div class="dialog-container">
        <div class="dialog-title">
          <div class="dialog-title-item">中文</div>
        </div>
        <div class="dialog-content">
          <div class="dialog-flex">
            <div class="dialog-label">题干：</div>
            <markdown-it
              class="dialog-value mr-12"
              :md="topicInfo.stem"
            ></markdown-it>
          </div>
          <div
            class="dialog-flex"
            v-for="(option, index) in topicInfo.options"
            :key="index"
          >
            <div class="dialog-label">
              <div>选项 {{ index + 1 }}：</div>
              <div class="brand-color" v-if="index == topicInfo.correctIndex">
                （正确答案）
              </div>
            </div>
            <markdown-it
              class="dialog-value mr-12"
              :md="option.content"
            ></markdown-it>
          </div>
          <div class="dialog-flex">
            <div class="dialog-label">解析：</div>
            <markdown-it
              class="dialog-value mr-12"
              :md="topicInfo.analysis"
            ></markdown-it>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="submit-btn">
          <zhu-button
            class="mr-12 w-90"
            text="取消"
            :shadow="false"
            :plain="true"
            type="primary"
            :loading="btnLoading"
            @click="previewVisible = false"
          ></zhu-button>
          <zhu-button
            class="mr-12 w-200"
            text="提交"
            :shadow="false"
            type="primary"
            :loading="btnLoading"
            @click="submit"
          ></zhu-button>
        </div>
      </span>
    </el-dialog>
    <QuestionRepeatDialog
      :repeatDialog.sync="show"
      :dialogStep.sync="step"
      :dialogLoading.sync="submitLoading"
      :dialogInfo="showInfo"
      @fixQuestion="handleFixQuestion"
    ></QuestionRepeatDialog>
  </div>
</template>

<script>
import skillService from "@/global/service/skill";
import SelectSkillStack from "@/components/SelectSkillStack.vue";
import * as XLSX from "xlsx";
import kcellService from "@/global/service/kcell";
import Markdown from "@/components/Markdown";
import MarkdownIt from "@jiker/markdown-it/MarkdownIt.vue";
import QuestionRepeatDialog from "@/components/QuestionRepeatDialog.vue";
const topicInfoInit = function() {
  return {
    level: null,
    knowledge_ids: [],
    knowledge_names: "",
    common_industries: [],
    stem: "",

    analysis: "",

    time_max: 60,
    source_type: "",
    question_type: "",
    options: [
      {
        content: ""
      },
      {
        content: ""
      },
      {
        content: ""
      },
      {
        content: ""
      }
    ],
    correctIndex: null,
    language: ["zh-cn"]
  };
};
export default {
  components: {
    SelectSkillStack,
    Markdown,
    MarkdownIt,
    QuestionRepeatDialog
  },
  data() {
    return {
      nextLoading: false,
      btnLoading: false,
      basicInfo: {
        teacherId: null,
        stackId: null
      },
      searchNameLoading: false,
      teacherList: [],
      pageStep: 1,
      importFile: null,
      sheetData: [],
      needKeys: {
        question_type: "题目类别",
        level: "难度等级",
        knowledge_names: "所属知识点",
        time_max: "建议最长答题时间",
        source_type: "题目来源",
        stem: "题干",
        option_1: "选项1",
        option_2: "选项2",
        option_3: "选项3",
        option_4: "选项4",
        currentOption: "正确答案",
        analysis: "解析"
      },
      questionIndex: 0,

      show: false,
      type: [],
      step: "check",
      showInfo: {},
      submitLoading: false,
      dialogLoading: false,
      topicInfo: topicInfoInit(),
      topicRules: {
        level: { required: true, trigger: "blur" },
        knowledge_ids: { required: true, trigger: "blur" },
        stem: { required: true, trigger: "blur" },
        en_stem: { required: true, trigger: "blur" },
        fr_stem: { required: true, trigger: "blur" },
        analysis: { required: true, trigger: "blur" },
        en_analysis: { required: true, trigger: "blur" },
        fr_analysis: { required: true, trigger: "blur" },
        source_type: { required: true, trigger: "blur" },
        question_type: { required: true, trigger: "blur" }
      },
      sourceList: [
        { value: 1, label: "原创" },
        { value: 2, label: "网络" },
        { value: 3, label: "翻译" },
        { value: 4, label: "购买" },
        { value: 5, label: "改编" },
        { value: 6, label: "其他" }
      ],
      typeList: [
        { value: 4, label: "场景" },
        { value: 2, label: "概念" },
        { value: 3, label: "代码" },
        { value: 1, label: "其他" }
      ],
      levelList: [
        { value: 1, label: "简单" },
        { value: 2, label: "普通" },
        { value: 3, label: "困难" }
      ],
      selectVisible: false,
      filterText: "",
      tree: [
        {
          text: "",
          children: []
        }
      ],
      treeProps: {
        label: "text",
        children: "children"
      },
      selectKnowledgeArr: [],
      previewVisible: false,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  created() {
    this.getConst();
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    questionIndex(val) {
      this.getTopicInfo(val);
    }
  },
  methods: {
    skipThisTopic() {
      this.questionIndex++;
      this.selectKnowledgeArr = [];
    },
    handleToNext() {
      const { stackId, teacherId } = this.basicInfo;
      if (stackId && teacherId && this.importFile) {
        this.nextLoading = true;
        this.readExcelToJson(this.importFile)
          .then(res => {
            this.sheetData = res;
            const keys = Object.keys(this.sheetData[0]);
            for (let item in this.needKeys) {
              if (keys.indexOf(this.needKeys[item]) === -1) {
                this.$message.error(
                  `缺少「${this.needKeys[item]}」字段，请使用正确的模版`
                );
                return;
              }
            }
            this.questionIndex = 0;
            this.getTopicInfo(0);
            this.pageStep = 2;
          })
          .finally(() => {
            this.nextLoading = false;
          });
        this.getKnowledgePoint();
      } else {
        this.$message.error("请填写完整以上信息");
      }
    },
    getKnowledgePoint() {
      skillService
        .skillKnowledge(this.basicInfo.stackId)
        .then(res => {
          this.tree[0].text = "所有知识点";
          this.tree[0].children = res;
          this.setDisabled(this.tree);
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    downloadTemplate() {
      // 通过链接下载文件
      const link = document.createElement("a");
      link.href =
        "https://assets.jiker.com/_for_common_project/2023/0525/admin/skill_question_import_template.xlsx";
      link.click();
    },
    handleBeforeUpload(file) {
      if (!file || !this.validate(file)) {
        return false;
      }
      this.importFile = file;
      return true;
    },
    validate(file) {
      const size = 1024 * 1024;
      const fileName = file.name;
      const suffix = fileName.split(".").pop();
      const imageRegex = new RegExp(`${["xlsx"].join("|")}`, "i");
      if (file.size > size || !imageRegex.test(suffix)) {
        this.$message.error(`请上传不大于 1MB 且格式为 xlsx 的文件`);
        return false;
      }
      return true;
    },
    readExcelToJson(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = e => {
          let data = new Uint8Array(e.target.result);
          let workbook = XLSX.read(data, {
            type: "array"
          });
          //将Excel 第一个sheet内容转为json格式
          let worksheet = workbook.Sheets[workbook.SheetNames[0]];
          let json = XLSX.utils.sheet_to_json(worksheet);
          resolve(json);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    searchTeacher(query) {
      if (query !== "") {
        this.searchNameLoading = true;
        skillService
          .teacherList({ search_text: query })
          .then(res => {
            this.teacherList = res.list.map(item => {
              return {
                value: item.uid,
                label: item.realname ? item.realname : item.nickname
              };
            });
          })
          .finally(() => {
            this.searchNameLoading = false;
          });
      } else {
        this.teacherList = [];
      }
    },

    // 第二步
    getTopicInfo(index) {
      if (index >= this.sheetData.length) {
        this.$message.success("已经上传完成所有题目");
        this.questionIndex = 0;
        this.pageStep = 1;
        this.sheetData = [];
        this.importFile = null;
        return;
      }
      const item = this.sheetData[index];
      const keyArr = this.needKeys;
      this.topicInfo.level = this.getValueByLabel(
        this.levelList,
        item[keyArr.level]
      );
      this.topicInfo.knowledge_ids = [];

      this.topicInfo.knowledge_names = item[keyArr.knowledge_names];
      this.topicInfo.common_industries = [];
      this.topicInfo.stem = item[keyArr.stem];
      this.topicInfo.analysis = item[keyArr.analysis];
      this.topicInfo.time_max = item[keyArr.time_max];
      this.topicInfo.source_type = this.getValueByLabel(
        this.sourceList,
        item[keyArr.source_type]
      );
      this.topicInfo.question_type = this.getValueByLabel(
        this.typeList,
        item[keyArr.question_type]
      );
      this.topicInfo.options[0].content = item[keyArr.option_1];
      this.topicInfo.options[1].content = item[keyArr.option_2];
      this.topicInfo.options[2].content = item[keyArr.option_3];
      this.topicInfo.options[3].content = item[keyArr.option_4];
      let correctOption = Number(item[keyArr.currentOption].trim().substr(-1));
      this.topicInfo.correctIndex = correctOption ? correctOption - 1 : null;
    },

    getValueByLabel(list, label) {
      const index = list.findIndex(item => item.label === label.trim());
      if (index || index === 0) {
        return list[index].value;
      } else {
        return null;
      }
    },
    showSelectDialog() {
      this.selectVisible = true;
      this.$nextTick(() => {
        this.$refs["tree"].setCheckedKeys(this.topicInfo.knowledge_ids);
      });
    },
    setDisabled(arr) {
      arr.forEach(data => {
        if (data.children.length) {
          data.disabled = true;
          this.setDisabled(data.children);
        }
      });
      return arr;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.text.indexOf(value) !== -1;
    },
    getKnowledgeArr(ids = [], arr, result = [], parentName) {
      arr.forEach(item => {
        let name = parentName
          ? `${parentName} => ${item.text}`
          : ` ${item.text}`;
        if (ids.includes(item.id)) {
          result.push({
            id: item.id,
            name
          });
        }
        if (item.children.length) {
          this.getKnowledgeArr(ids, item.children, result, name);
        }
      });
      this.selectKnowledgeArr = result;
    },
    handleNodeClick(data) {
      if (data.children.length !== 0) return;
      const checked = this.$refs["tree"].getCheckedKeys();
      const index = checked.indexOf(data.id);
      if (index === -1) {
        if (checked.length >= 2) {
          return this.$message.error("您最多选择两个知识点");
        }
        checked.push(data.id);
        this.$refs["tree"].setCheckedKeys(checked);
      } else {
        checked.splice(index, 1);
        this.$refs["tree"].setCheckedKeys(checked);
      }
    },
    handleNodeCheck(data, e) {
      const arr = this.$refs["tree"].getCheckedKeys();
      if (arr.length >= 3) {
        const index = arr.indexOf(data.id);
        arr.splice(index, 1);
        e.checkedKeys.splice(index, 1);
        e.checkedNodes.splice(index, 1);
        this.$refs["tree"].setCheckedKeys(arr);
        return this.$message.error("您最多选择两个知识点");
      }
    },
    selectKnowledgePoint() {
      const selected = this.$refs["tree"].getCheckedNodes(true);
      if (selected.length === 0) {
        this.$message.error("请选择知识点");
        return;
      }
      this.topicInfo.knowledge_ids = selected.map(data => data.id);
      this.getKnowledgeArr(this.topicInfo.knowledge_ids, this.tree[0].children);
      this.clearSelectInfo();
    },
    getQuestionCount(data) {
      let level = ["简单", "普通", "困难"];
      let detail;
      if (
        "question_detail" in data &&
        data.question_detail !== null &&
        data.question_count !== 0 &&
        data.question_detail.levels.length
      ) {
        detail = data.question_detail.levels
          .map(item => `${level[item.level - 1]}${item.count}`)
          .join(" / ");
        return `( ${detail} )`;
      }
    },
    handleFixQuestion() {
      this.show = false;
      this.step = "check";
      this.showInfo = {};
    },
    clearSelectInfo() {
      this.selectVisible = false;
    },
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },

    submit() {
      if (this.btnLoading) return;
      if (this.topicInfo.knowledge_ids.length === 0) {
        this.$message.error("请选择知识点");
        return;
      }
      this.$refs["topicInfo"].validate(val => {
        if (!val) {
          this.$message.error("缺少必要参数");
          return;
        }
        let options = [];
        let translator = {};
        options = this.topicInfo.options.map(data => {
          return {
            correct: false,
            translator: {
              "zh-cn": {
                option: data.content
              }
            }
          };
        });
        translator = {
          "zh-cn": {
            stem: this.topicInfo.stem,
            analysis: this.topicInfo.analysis
          }
        };
        if (!this.topicInfo.correctIndex && this.topicInfo.correctIndex !== 0) {
          this.$message.error("请选择正确答案");
          return;
        }
        options[this.topicInfo.correctIndex].correct = true;
        const params = {
          stack_id: this.basicInfo.stackId,
          creator_id: this.basicInfo.teacherId,
          level: this.topicInfo.level,
          knowledge_points: this.selectKnowledgeArr,
          time_max: this.topicInfo.time_max,
          source_type: this.topicInfo.source_type,
          question_type: this.topicInfo.question_type,
          languages: this.topicInfo.language,
          translator,
          options,
          common_industries: this.topicInfo.common_industries
        };
        this.btnLoading = true;
        this.show = true;
        this.submitLoading = true;
        skillService
          .topicAdd(params)
          .then(res => {
            if (res.question_id) {
              this.step = "pass";
              this.submitLoading = false;
              setTimeout(() => {
                this.$refs["topicInfo"].resetFields();
                this.selectKnowledgeArr = [];
                this.show = false;
                this.step = "check";
                this.questionIndex++;
              }, 1500);
            } else {
              this.step = "reject";
              this.showInfo = res;
              this.submitLoading = false;
            }
          })
          .finally(() => {
            this.btnLoading = false;
            this.previewVisible = false;
            this.$nextTick(() => {
              document.getElementById("topic-card").scrollIntoView();
            });
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page-container {
  .page-container-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .title {
      display: inline-block;
    }
  }
}

.preview-btn {
  position: relative;
  width: 100%;
  height: 40px;
  text-align: center;
}
.submit-btn {
  text-align: center;
  .el-checkbox {
    margin-top: 12px;
  }
}
/deep/.el-dialog__body {
  padding-bottom: 0px !important;
}
.dialog-tree-container {
  padding: 0 20px;
  max-height: 340px;
  overflow: scroll;

  .tree-label > span:last-child {
    margin-left: 10px;
    display: inline-block;
  }
}
.upload-btn {
  display: block;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  width: 360px;
  height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .el-icon-upload {
    margin: 10px;
  }
  .icon-file {
    height: 40px;
    margin-top: 32px;
  }
  .upload-title {
    height: 20px;
    font-size: 12px;
    color: #409eff;
    line-height: 20px;
    margin: 12px auto 4px;
  }
  .upload-subtitle {
    height: 20px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    line-height: 20px;
  }

  .icon-file {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .svg-class {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    .text {
      max-width: 200px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 15px;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .upload-delete {
    position: absolute;
    top: 8px;
    right: 12px;
    height: 22px;
    font-size: 14px;
    font-weight: 400;
    color: red;
    display: flex;
    align-items: center;
    img {
      margin-right: 4px;
      width: 16px;
      height: 16px;
    }
  }
}

.dialog-container {
  padding: 0 30px;
  max-height: 500px;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  .dialog-title {
    width: 700px;
    display: flex;
    justify-content: space-around;
    font-weight: 500;
    font-size: 16px;
  }
  .dialog-content {
    margin: 0 auto;
    width: 700px;
    .dialog-flex {
      display: flex;
      margin: 12px 0;
      .dialog-label {
        flex: none;
        width: 85px;
        text-align: right;
      }
      .dialog-value {
        flex: 1;
        &.jiker-markdown-it {
          padding: 0;
        }
        &.dialog-operation {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
.popover-title {
  margin-bottom: 10px;
}
.popover-list {
  padding-left: 35px;
  .popover-item {
    font-size: 14px;
  }
}
.el-icon-question {
  font-size: 16px;
}
.language-container {
  display: flex;
}
.language-box {
  .language-title {
    text-align: center;
    margin-bottom: 20px;
  }
}
.tooltip-content {
  .tooltip-content-item {
    display: flex;
    line-height: 22px;
  }
  .strong-name {
    font-size: 14px;
    color: #333;
    width: 120px;
    text-align: right;
  }
  .desc {
    color: #606266;
  }
}
</style>
